import React from 'react'
import {GameImageContainerComponent} from '../common/parts/game-image-container.component/game-image-container.component';
import {GameDetailsContainerComponent} from './parts/game-details-container/game-details-container.component';
import {OrbitComponent} from '../../base-components/orbit-component/orbit-component';
import {GameInfo} from '../../../services/games/game-info';
import {observer} from 'mobx-react';
import {GameBox} from './boxes/game/game.box';
import {PlayRealButtonBox} from './boxes/play-real-button/play-real-button.box';
import {GameImageContainerBox} from './boxes/game-image-container/game-image-container.box';
import {GameNumberBadgeBox} from "./boxes/game-number-badge/game-number-badge.box";
import {Check, TimeSpan} from "@sparkware/app-utils";
import { GameIconAnimationState } from '../common/parts/game-image/game-image.component';
import {CyClass} from '../../../../common/cy-classes';

export interface SingleGameRegularTemplateComponentProps {
    className: string;
    gameInfo: GameInfo;
    disableGameInfoHover: boolean;
    onMouseEnter: () => void;
    onMouseLeave: () => void;
    onOpenRealGame: () => void;
    onOpenAnonymousGame: () => void;
    onOpenInfoPage: () => void;
    onAnimationIconStateChange?(state: GameIconAnimationState): void;
    gameIndex?: number;
    useSquareIcons?: boolean;
    showNumberBadge?: boolean;
    hasTwoLinesTitle: boolean;
}

@observer
export class SingleGameRegularTemplateComponent extends OrbitComponent<SingleGameRegularTemplateComponentProps> {
    public fontLoadTimeout: ReturnType<typeof setTimeout> | null = null;

    public state = {
        isFontLoaded: false
    }

    get gameInfo(): GameInfo {
        return this.props.gameInfo;
    }

    private _renderPlayRealGameButton() {
        if (this.services.device.os.isMobileOS || this.services.mediaQuery.anyHoverNone) {
            return null;
        }
        return (<PlayRealButtonBox className={CyClass('cy-play-real-game-button')} />);
    }

    private _renderGameNumberBadge() {
        if(!this.props.showNumberBadge || Check.isNullOrUndefined(this.props.gameIndex)) {
            return null;
        }

        return (
            <GameNumberBadgeBox className={'cy-game-number-badge'} isFontLoaded={this.state.isFontLoaded}>
                {this.props.gameIndex+1}
            </GameNumberBadgeBox>
        )
    }

    componentDidMount() {
        this._checkFontsLoaded();
    }

    componentWillUnmount() {
        if (this.fontLoadTimeout) {
            clearTimeout(this.fontLoadTimeout);
        }
    }

    private async _checkFontsLoaded() {
        if (!('fonts' in document)) {
            this.setState({ isFontLoaded: true });
            return;
        }
    
        const timeout = new Promise(resolve => 
            setTimeout(resolve, TimeSpan.fromSeconds(3).totalMilliseconds)
        );
    
        try {
            await Promise.race([document.fonts.ready, timeout]);
        } catch (error) {
            this.services.logger.warning('Font loading failed:', error);
        }
        
        this.setState({ isFontLoaded: true });
    }

    render() {
        return (
            <>
                {this._renderGameNumberBadge()}

                <GameBox className={`cy-single-game-regular-template ${this.props.className}`}
                            onMouseEnter={this.props.onMouseEnter}
                            onMouseLeave={this.props.onMouseLeave}
                            squareGameIcon={this.props.useSquareIcons}
                >

                        <GameImageContainerComponent gameInfo={this.gameInfo}
                                                        box={GameImageContainerBox}
                                                        onOpenRealGame={this.props.onOpenRealGame}
                                                        useSquareIcons={this.props.useSquareIcons}
                                                        playRealGameButton={this._renderPlayRealGameButton()}
                                                        onAnimationIconStateChange={this.props.onAnimationIconStateChange}
                        />

                        <GameDetailsContainerComponent gameInfo={this.gameInfo}
                                                    disableGameInfoHover={this.props.disableGameInfoHover}
                                                    onOpenInfoPage={this.props.onOpenInfoPage}
                                                    onOpenAnonymousGame={this.props.onOpenAnonymousGame}
                                                    squareGameIcon={this.props.useSquareIcons}
                                                    hasTwoLinesTitle={this.props.hasTwoLinesTitle}
                        />
                </GameBox>
            </>
        );
    }
}
